import { render, staticRenderFns } from "./ModalCriaProcessoERegistro.vue?vue&type=template&id=f4fe5018&scoped=true"
import script from "./ModalCriaProcessoERegistro.vue?vue&type=script&lang=js"
export * from "./ModalCriaProcessoERegistro.vue?vue&type=script&lang=js"
import style0 from "./ModalCriaProcessoERegistro.vue?vue&type=style&index=0&id=f4fe5018&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4fe5018",
  null
  
)

export default component.exports